import React from "react";
import { services } from "../mock";
import { useReveal } from "../hooks/useReveal";

function ServiceRow({ service, index }) {
  const { ref, visible } = useReveal();
  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${index * 80}ms` }}
      className={`group grid md:grid-cols-12 gap-4 md:gap-8 items-start py-10 border-t border-[var(--line)] reveal ${
        visible ? "is-visible" : ""
      }`}
    >
      <div className="md:col-span-1 font-serif-display text-xl text-[var(--accent)]">
        {service.number}
      </div>
      <h3 className="md:col-span-4 font-serif-display text-3xl md:text-4xl font-light tracking-[0.015em] transition-transform duration-500 group-hover:translate-x-2">
        {service.title}
      </h3>
      <p className="md:col-span-7 text-[16px] leading-relaxed text-[var(--muted)] max-w-xl">
        {service.description}
      </p>
    </div>
  );
}

export default function Services() {
  return (
    <section id="services" className="py-24 md:py-32 scroll-mt-20">
      <div className="container-wide">
        <div className="max-w-2xl mb-14">
          <span className="section-label">What I do</span>
          <h2 className="font-serif-display font-light text-5xl md:text-6xl mt-4 tracking-[0.015em]">
            Services
          </h2>
        </div>
        <div className="border-b border-[var(--line)]">
          {services.map((s, i) => (
            <ServiceRow key={s.number} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
